var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnimal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9 13.0999C15.4083 10.1583 12.5833 7.7666 9.6 7.7666C6.35833 7.7666 3.50833 10.3916 3.23333 13.6249C3.125 14.8749 3.525 16.0583 4.35 16.9499C5.16666 17.8416 6.31666 18.3333 7.56666 18.3333H11.4667C12.875 18.3333 14.1083 17.7833 14.95 16.7916C15.7917 15.7999 16.125 14.4833 15.9 13.0999Z",
    fill: "#5DCCC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56667 6.55008C9.91516 6.55008 11.0083 5.45691 11.0083 4.10841C11.0083 2.75992 9.91516 1.66675 8.56667 1.66675C7.21817 1.66675 6.125 2.75992 6.125 4.10841C6.125 5.45691 7.21817 6.55008 8.56667 6.55008Z",
    fill: "#5DCCC6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1167 7.52492C15.2397 7.52492 16.15 6.61456 16.15 5.49159C16.15 4.36861 15.2397 3.45825 14.1167 3.45825C12.9937 3.45825 12.0833 4.36861 12.0833 5.49159C12.0833 6.61456 12.9937 7.52492 14.1167 7.52492Z",
    fill: "#5DCCC6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.125 10.7749C18.0225 10.7749 18.75 10.0474 18.75 9.1499C18.75 8.25244 18.0225 7.5249 17.125 7.5249C16.2275 7.5249 15.5 8.25244 15.5 9.1499C15.5 10.0474 16.2275 10.7749 17.125 10.7749Z",
    fill: "#5DCCC6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28333 9.14992C4.40631 9.14992 5.31667 8.23956 5.31667 7.11659C5.31667 5.99361 4.40631 5.08325 3.28333 5.08325C2.16035 5.08325 1.25 5.99361 1.25 7.11659C1.25 8.23956 2.16035 9.14992 3.28333 9.14992Z",
    fill: "#5DCCC6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimal);
export default __webpack_public_path__ + "static/media/animal.10e85155fd3baaa507c5ce48d9d1d447.svg";
export { ForwardRef as ReactComponent };